import React from 'react';
import { Constants } from '../../shared/constants';
import { Box, Button, Typography } from '@mui/material';
import { IoMdCall } from "react-icons/io";
import useResponsive from '../../shared/utils/Responsive';
import { KnowMoreButton } from '../../shared/utils/CustomButton';

const HeroSection = () => {
  const isSmallScreen = useResponsive("md")
  return (
    <>
      <Box
        sx={{
          position: "relative",
          backgroundImage: isSmallScreen
            ? `url(${Constants.customImages.HeroSectionImgJpg})`
            : `url(${Constants.customImages.HeroSectionImg})`,
          backgroundSize: "cover",
          backgroundPosition: "bottom",
          backgroundRepeat: "no-repeat",
          padding: { xs: "20px", sm: "40px", md: "120px 40px" },
          borderRadius: "40px",
          overflow: "hidden",
          // minHeight:"40vh"
        }}
      >
        <Typography variant='h2' color='primary.main' sx={{ textAlign: { xs: "center", lg: "start" } }}>
          Lighthouse for Education: Empowering Learning and Teaching
        </Typography>
        <Typography variant='body1' color='primary.main' my={2} textAlign={{ xs: "center", lg: "start" }} sx={{ width: { xs: "100%", md: "70%", } }}>
          {
            isSmallScreen ? "MySkill's 'Lighthouse for Education' offers personalized learning, professional development, and innovative" : "MySkill's 'Lighthouse for Education' offers personalized learning, professional development, and innovative tools to help students excel and educators improve their teaching in today’s dynamic education environment."
          }
        </Typography>
        <Box sx={{ display: "flex", justifyContent: { xs: "center", lg: "start" } }}>
          <Button variant='gost' startIcon={<IoMdCall style={{ fontSize: "20px", color: "#DC143C" }} />}>
            Contact Us
          </Button>
        </Box>
        {
          !isSmallScreen && (
            <Box width={"30%"} sx={{ position: "absolute", display: "flex", justifyContent: "start", alignItems: "end", flexDirection: "column", right: "15px", bottom: "15px" }}>
              <KnowMoreButton text={"Know More"} />
              <Typography variant='body2' lineHeight={"15px"} fontSize={"12px"} color='primary.main' textAlign={"end"} mt={1} >MySkill is an educational institution that provides quality learning experiences for students across various academic levels</Typography>
            </Box>
          )
        }
      </Box>
    </>
  );
};

export default HeroSection;
